module.exports = __webpack_public_path__ + "img/bg_cai@2x.084d1782.png";